/* IMPORTS
	You can import directly from node_modules here.
*/
import $ from 'jQuery';
import 'what-input';

/*
	LIBRARY IMPORTS
	Utilities, plugins, and behaviors that aren't tied to a specific component.
*/
import alerts from './libraries/alerts';
import anchorLinks from './libraries/anchor-links';
import linkContainer from './libraries/link-container';
import './libraries/filters';
import './libraries/hoverintent.min.js';
import './libraries/slick.min.js';
import './libraries/what-input.js';
import './libraries/ScrollTrigger.min.js';

/*
	COMPONENT IMPORTS
	For specific components.
*/
import '../blocks/accordion-block/js/accordion-block';
import '../blocks/newsletter/js/newsletter';
import '../blocks/upcoming-news/js/upcoming-news';
import imagesAutoSlider from '../blocks/hero/js/hero.js';
import carouselBlock from '../blocks/carousel/js/carousel.js';
import testimonialCarouselBlock from '../blocks/testimonial-carousel/js/testimonial-carousel.js';
import imageGalleryWithText from '../blocks/image-gallery-with-text/js/image-gallery-with-text.js';
import peopleList from '../blocks/people-list/js/people-list.js';
// import '../modules/some-module/js/some-module';
import './components/alerts.js';
import './components/cookies.js';
import './components/accessibility.js';
import './components/header.js';
import './components/main-menu.js';

// Easy console access to jQuery through '$'
window.$ = $;

/* INITIALIZATION */
$(() => {
  $('body').addClass('document-ready');
});

$(document).ready(function() {
	/* Higher priority first, lower priority later */
	alerts();
	linkContainer();
	anchorLinks();
	imagesAutoSlider();
	imageGalleryWithText();
	carouselBlock();
	testimonialCarouselBlock();
	peopleList();

	// Apply this style to paragraphs that have an iframe
	$('.block__inner .paragraph-regular:has(iframe)').css('padding-top', '56.25%');
});

// FOUC on-fully-loaded make the page visible:
addEventListener('load', (e) => {
  document.documentElement.style.visibility = 'visible';
});